import { createFileRoute, notFound } from "@tanstack/react-router"
import { SensingStationDetail } from "@/components/sensnet/sensingStations"

export const Route = createFileRoute("/sensnet/sensing-stations/$stationNumber")({
  staticData: {
    title: 'Station Profile',
    isSecured: true,
  },
  component: StationProfilePage,
})

function StationProfilePage() {
  const { stationNumber } = Route.useParams()
  const parsed = parseInt(stationNumber, 10)

  if (isNaN(parsed)) {
    throw notFound()
  }

  return (
    <div className="p-6">
      <SensingStationDetail stationNumber={parsed} />
    </div>
  )
}
